export default "__VITE_ASSET__DCEjLQPV__"